import { deepDives } from "@/mocks/homeData";

export default function DeepDiveSection() {
  return (
    <section id="deepdive" className="w-full px-4 py-10 md:px-8 md:py-12">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4 border-b border-background-200 pb-3">
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-900 text-background-50">
            <i className="ri-eye-line text-lg" style={{ lineHeight: 1 }} />
          </span>
          <div className="flex flex-col leading-tight">
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              内幕深扒 · 值班专栏
            </h2>
            <span className="text-xs text-foreground-500">把公开材料里最容易忽略的那一层，单独拎出来讲</span>
          </div>
        </div>
        <span className="font-label text-xs text-foreground-400">每日 09:00 / 21:00 更新</span>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {deepDives.map((item, index) => (
          <article
            key={item.title}
            className="reveal group flex cursor-pointer gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-5"
            style={{ animationDelay: `${index * 70}ms` }}
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
              <i className="ri-article-line text-xl" style={{ lineHeight: 1 }} />
            </span>

            <div className="min-w-0 flex-1">
              <span className="text-[11px] font-medium tracking-wide text-secondary-700">{item.category}</span>
              <h3 className="mt-1 text-sm font-bold leading-relaxed text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                {item.title}
              </h3>
              <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                {item.excerpt}
              </p>

              <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line h-3.5 w-3.5" style={{ lineHeight: 1 }} />
                  {item.author}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line h-3.5 w-3.5" style={{ lineHeight: 1 }} />
                  {item.date}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line h-3.5 w-3.5" style={{ lineHeight: 1 }} />
                  {item.reads}
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}